import * as React from "react";
import {FC, InputHTMLAttributes} from "react";
import parse from "html-react-parser";
import {IFormFieldProps} from "../../IFormFieldProps";
import Element from "../../../../domain/Element/Element";
import Input from "../input/Input";
import RangeSlider from "../range-slider/RangeSlider";
import MagicCheckbox from "../checkbox/MagicCheckbox";
import PercentageInputRange from "./PercentageInputRange";
import PercentageInputInteger from "./PercentageInputInteger";
import { EElementType } from "../../../../domain/Element/EElementType";
import ValidateConditionUseCase from "../../../../domain/Condition/UseCase/ValidateConditionUseCase";
import FormGateway from "../../../../gateway/Form/FormGateway";
import { isDisabledCondition, isVisibleCondition } from "../../../util/validateCondition";

interface IProps extends InputHTMLAttributes<HTMLInputElement>, IFormFieldProps {
    element: Element
    percentageElements: (Element | undefined)[] | undefined
    formData: Record<string, unknown> | []
    defaultValue: string | number | undefined
    clearErrors: (id: string | undefined) => void
    register: (() => void) | undefined
    readOnly?: boolean
}

const PercentageInputRangeGroup: FC<IProps> = (
    {
        element,
        percentageElements,
        formData,
        defaultValue,
        register,
        clearErrors,
        error,
        readOnly
    }
) => {
    const attributes = element?.attributes

    const isVisileElement = (element) => {
        const validateConditionUseCase = new ValidateConditionUseCase(new FormGateway())

        const validationState = (undefined !== element.condition)
            ? validateConditionUseCase.execute(element.condition)
            : true

        if (
            isDisabledCondition(element, validationState)
            || !isVisibleCondition(element, validationState)
            || '' === (attributes?.presentation ?? '')
        ) {
            return false
        }
        return true
    }
    return (
        <>
            <div className={element.cssClasses + ` group-percentage-select-range`} title={attributes?.help}>
                <div className={`group-percentage-select-range-label`}>
                    <label>{parse(attributes?.label ?? '')}</label>
                </div>
                <div className={`group-percentage-select-range-content`}>
                    {
                        percentageElements?.map(
                            (childElement) => (
                                childElement && isVisileElement(childElement) && (childElement.type === EElementType.INPUT_PERCENTAGE_RANGE ?
                                <PercentageInputRange
                                    element={childElement}
                                    formData={formData}
                                    error={error}
                                    register={register}
                                    readOnly={readOnly}
                                /> : 
                                <PercentageInputInteger
                                    element={childElement}
                                    formData={formData}
                                    register={register}
                                    clearErrors={clearErrors}
                                    error={error}
                                    readOnly={false}

                                />
                            ))
                        )
                    }
                </div>
                <div>
                    <Input
                        classes={'u-hide'}
                        register={register}
                        clearErrors={clearErrors}
                        type={'number'}
                        error={error}
                        id={element.id}
                        name={element.name}
                        required={attributes?.required}
                        readOnly={readOnly || attributes?.readonly}
                        defaultValue={defaultValue}
                    />
                </div>
            </div>
        </>
    )
}

export default PercentageInputRangeGroup